import { Box } from '@mui/material'

/** The small "New" label beside a menu item. `inverted` suits a navy background. */
export default function NewPill({ inverted = false }: { inverted?: boolean }) {
  return (
    <Box
      component="span"
      sx={{
        ml: 0.5,
        px: '7px',
        py: '2px',
        borderRadius: '10px',
        bgcolor: inverted ? '#fff' : '#1C3045',
        color: inverted ? '#1C3045' : '#fff',
        fontSize: '11px',
        fontWeight: 600,
        letterSpacing: '0.04em',
        lineHeight: 1.3,
        textTransform: 'uppercase',
      }}
    >
      New
    </Box>
  )
}
